module.exports = __webpack_public_path__ + "static/media/inicio-background.687b7508.jpg";